import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {signupToEvent, toggleDialogSubscribe, toggleDialogSubscribeSuccess} from '../../actions';
import {withLocalize, Translate} from 'react-localize-redux';
import translations from '../../translations/translations_event_details';
import ReactHtmlParser from 'react-html-parser';
import moment from 'moment';
import 'moment/min/locales';
import 'moment/locale/fr';
import momentDurationFormat from 'moment-duration-format';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DoneIcon from '@material-ui/icons/Done';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import MenuItem from "@material-ui/core/MenuItem/MenuItem";
import FormHelperText from "@material-ui/core/FormHelperText/FormHelperText";
import Checkbox from "@material-ui/core/Checkbox/Checkbox";
import ListItemText from "@material-ui/core/ListItemText/ListItemText";
import LoadingSpinner from '../../../Layout/components/LoadingSpinner';

class EventDetailsSubscribe extends Component {
    state = {
        checkin_degrees: [],
        checkin_number_students_expected: '',
        checkin_number_accompagnants: '',
        checkin_remarks: '',
        checkin_date: '',
    };

    constructor(props) {
        super(props);

        this.props.addTranslation(translations);
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.signupOrOut !== this.props.signupOrOut) {
            if (this.props.signupOrOut) {
                if (this.props.currentUserSubscribed && this.props.dialogSubscribeOpen) {
                    // The has just been subscribed.
                    // Hide the subscribe dialog and show ths success dialog.
                    this.props.toggleDialogSubscribeSuccess();
                }
            }
        }
    }

    handleSignup = (e) => {
        e.preventDefault();

        const {event} = this.props;

        const data = {
            degrees: this.state.checkin_degrees,
            number_students_expected: this.state.checkin_number_students_expected,
            number_accompagnants: this.state.checkin_number_accompagnants,
            remarks: this.state.checkin_remarks,
            date: this.state.checkin_date,
        };

        this.props.signupToEvent(event.slug, data);
    };

    handleChange = name => e => {
        this.setState({
            [name]: e.target.value,
        });
    };

    handleCloseDialog = () => {
        this.props.toggleDialogSubscribe();
    };

    handleCloseSuccessDialog = () => {
        this.props.toggleDialogSubscribeSuccess();
    };

    render() {
        const {event, signupOrOutError, signupOrOutLoading, dialogSubscribeOpen, dialogSubscribeSuccessOpen} = this.props;
        const signupErrorsData = (signupOrOutError.hasOwnProperty('data')) ? signupOrOutError.data : {};

        momentDurationFormat(moment);
        moment.locale('fr');

        let title = event.title;
        if (event.title_html !== '' && event.title_html !== null) {
            title = event.title_html;
        }

        const nowDatetime = moment().format('YYYY-MM-DD');

        const degreesList = [
            { key: 1, value: this.props.translate('event_details.degree_harmos_1')},
            { key: 2, value: this.props.translate('event_details.degree_harmos_2')},
            { key: 3, value: this.props.translate('event_details.degree_harmos_3')},
            { key: 4, value: this.props.translate('event_details.degree_harmos_4')},
            { key: 5, value: this.props.translate('event_details.degree_harmos_5')},
            { key: 6, value: this.props.translate('event_details.degree_harmos_6')},
            { key: 7, value: this.props.translate('event_details.degree_harmos_7')},
            { key: 8, value: this.props.translate('event_details.degree_harmos_8')},
            { key: 9, value: this.props.translate('event_details.degree_harmos_9')},
            { key: 10, value: this.props.translate('event_details.degree_harmos_10')},
            { key: 11, value: this.props.translate('event_details.degree_harmos_11')},
        ];

        return (
            <Fragment>
                <Dialog
                    open={dialogSubscribeOpen}
                    onClose={this.handleCloseDialog}
                    aria-labelledby="dialog-checkin-subscribe-title"
                    className="dialog-event-checkin"
                >
                    <DialogContent className="dialog-checkin-content">
                        <div id="dialog-checkin-subscribe-title">
                            <span className="title"><Translate id="event_details.enroll_to" /></span>
                            <span className="subtitle">{ReactHtmlParser(title)}</span>
                        </div>
                        <div className="fields">
                            {(Array.isArray(event.dates) && event.dates.length > 0) &&
                                <FormControl required className="formControl" margin="normal" fullWidth={true} error={signupErrorsData.date ? true : false}>
                                    <InputLabel htmlFor="checkin_date">
                                        <Translate id="event_details.date" />
                                    </InputLabel>
                                    <Select
                                        value={this.state.checkin_date}
                                        onChange={this.handleChange('checkin_date')}
                                        inputProps={{
                                            id: 'checkin_date',
                                        }}
                                    >
                                        {event.dates.filter(session => {
                                            // Display only the upcoming dates
                                            return session.date > nowDatetime;
                                        }).map((session, index) => {
                                            let inputValue = session.date;
                                            let date = moment(session.date, 'YYYY-MM-DD').format('dddd D MMMM YYYY');
                                            let hour = '';
                                            if (session.hour_start !== '' && session.hour_end !== '') {
                                                hour = '(' + session.hour_start.substring(0, 5) + ' à ' + session.hour_end.substring(0, 5) + ')';
                                                inputValue += ' ' + session.hour_start;
                                            } else if (session.hour_start !== '') {
                                                hour = '(' + session.hour_start.substring(0, 5) + ')';
                                                inputValue += ' ' + session.hour_start;
                                            }

                                            // Display the date only if a seat is still available
                                            if (session.max_seats > 0 && session.remaining_seats !== null) {
                                                if (session.remaining_seats > 0) {
                                                    return (
                                                        <MenuItem key={index} value={inputValue}>{date} {hour}</MenuItem>
                                                    )
                                                }
                                            } else {
                                                return (
                                                    <MenuItem key={index} value={inputValue}>{date} {hour}</MenuItem>
                                                )
                                            }
                                        })}
                                    </Select>
                                    {signupErrorsData.date && (<FormHelperText className="form-helper">{signupErrorsData.date}</FormHelperText>)}
                                </FormControl>
                            }

                            <FormControl required className="formControl" margin="normal" fullWidth={true} error={signupErrorsData.degrees ? true : false}>
                                <InputLabel htmlFor="checkin_degrees">
                                    <Translate id="event_details.degrees_harmos" />
                                </InputLabel>
                                <Select
                                    multiple
                                    id='checkin_degrees'
                                    value={this.state.checkin_degrees}
                                    onChange={this.handleChange('checkin_degrees')}
                                    input={<Input id="select-multiple-checkbox" />}
                                    renderValue={function (selected) {
                                        let titles = [];

                                        selected.forEach(function(key) {
                                            let degree = degreesList.find(degree => degree.key === key);
                                            if (degree) {
                                                titles.push(degree.value);
                                            }
                                        });

                                        return (
                                            <Fragment>{titles.join(', ')}</Fragment>
                                        );
                                    }}
                                >
                                    {degreesList.map(degree => (
                                        <MenuItem key={degree.key} value={degree.key}>
                                            <Checkbox checked={this.state.checkin_degrees.indexOf(degree.key) > -1} />
                                            <ListItemText primary={degree.value} />
                                        </MenuItem>
                                    ))}
                                </Select>
                                {signupErrorsData.degrees && (<FormHelperText className="form-helper">{signupErrorsData.degrees}</FormHelperText>)}
                            </FormControl>

                            <FormControl className="form-control" fullWidth={true} margin="normal" error={signupErrorsData.number_students_expected ? true : false}>
                                <InputLabel htmlFor="checkin_number_students_expected" className="form-label">
                                    <Translate id="event_details.number_students_expected" /> *
                                </InputLabel>
                                <Input type="number" id="checkin_number_students_expected" value={this.state.checkin_number_students_expected} onChange={this.handleChange('checkin_number_students_expected')} className="form-input" />
                                {signupErrorsData.number_students_expected && (<FormHelperText className="form-helper">{signupErrorsData.number_students_expected}</FormHelperText>)}
                            </FormControl>

                            <FormControl className="form-control" fullWidth={true} margin="normal" error={signupErrorsData.number_accompagnants ? true : false}>
                                <InputLabel htmlFor="checkin_number_accompagnants" className="form-label">
                                    <Translate id="event_details.number_accompagnants" /> *
                                </InputLabel>
                                <Input type="number" id="checkin_number_accompagnants" value={this.state.checkin_number_accompagnants} onChange={this.handleChange('checkin_number_accompagnants')} className="form-input" />
                                {signupErrorsData.number_accompagnants && (<FormHelperText className="form-helper">{signupErrorsData.number_accompagnants}</FormHelperText>)}
                            </FormControl>

                            <FormControl className="form-control" fullWidth={true} margin="normal" error={signupErrorsData.remarks ? true : false}>
                                <TextField  id="checkin_remarks" value={this.state.checkin_remarks} onChange={this.handleChange('checkin_remarks')} className="form-input" multiline rows={2} rowsMax={6} placeholder={this.props.translate('event_details.remarks')} />
                                {signupErrorsData.remarks && (<FormHelperText className="form-helper">{signupErrorsData.remarks}</FormHelperText>)}
                            </FormControl>
                        </div>
                        <div className="buttons">
                            {signupOrOutLoading ? (
                                <LoadingSpinner align="center" />
                            ) : (
                                <Fragment>
                                    <Button onClick={this.handleSignup} className="btn btn-confirm" variant="contained" color="primary" size="large" autoFocus>
                                        <DoneIcon className="icon" />
                                        <Translate id="event_details.button_confirmer" />
                                    </Button>
                                    <br />
                                    <Button onClick={this.handleCloseDialog} className="btn btn-cancel" variant="outlined" color="secondary" size="large">
                                        <Translate id="event_details.button_annuler" />
                                    </Button>
                                </Fragment>
                            )}
                        </div>
                    </DialogContent>
                </Dialog>

                <Dialog
                    open={dialogSubscribeSuccessOpen}
                    onClose={this.handleCloseSuccessDialog}
                    aria-labelledby="dialog-checkin-subscribe-confirm-title"
                    className="dialog-event-checkin"
                >
                    <DialogContent className="dialog-checkin-content">
                        <div id="dialog-checkin-subscribe-confirm-title">
                            <span className="title"><Translate id="event_details.title_thanks" /></span>
                            <span className="subtitle"><Translate id="event_details.notice_enroll_confirmed" /></span>
                        </div>
                        <div className="message">
                            <p><Translate id="event_details.notice_enroll" /></p>
                        </div>
                        <div className="buttons">
                            <Button onClick={this.handleCloseSuccessDialog} className="btn btn-cancel" variant="outlined" color="secondary" size="large">
                                <Translate id="event_details.button_close" />
                            </Button>
                        </div>
                    </DialogContent>
                </Dialog>
            </Fragment>
        );
    }
}

EventDetailsSubscribe.propTypes = {
    event: PropTypes.object.isRequired,
    currentUserSubscribed: PropTypes.bool.isRequired,
    signupToEvent: PropTypes.func.isRequired,
    toggleDialogSubscribe: PropTypes.func.isRequired,
    toggleDialogSubscribeSuccess: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
    signupOrOut: state.events.eventSignupOrOut,
    signupOrOutLoading: state.events.eventSignupOrOutLoading,
    signupOrOutError: state.events.eventSignupOrOutError,
    dialogSubscribeOpen: state.events.dialogSubscribeOpen,
    dialogSubscribeSuccessOpen: state.events.dialogSubscribeSuccessOpen,
    currentUserSubscribed: state.events.currentUserSubscribed,
});

export default connect(mapStateToProps, {signupToEvent, toggleDialogSubscribe, toggleDialogSubscribeSuccess})(withLocalize(EventDetailsSubscribe));


// WEBPACK FOOTER //
// ./src/features/Events/components/Details/EventDetailsSubscribe.js